<template>
    <div class="mt-5">
        <vx-card class="no-scroll-content" title="Settings">
             <vs-tabs v-model="activeTab" class="tab-action-btn-fill-container" position="left">
                <vs-tab label="Company" icon-pack="feather" icon="icon-clock">
                    <div class="tab-text">
                        <overtime :paymentMode="paymentModeId" :userId="userId" />
                    <!-- <user-edit-tab-account class="mt-4" :data="user_data" /> -->
                    </div>
                </vs-tab>
                <vs-tab label="Lookups" icon-pack="feather" icon="icon-plus">
                    <div class="tab-text">
                        <earnings :paymentMode="paymentModeId" :userId="userId" />
                    <!-- <user-edit-tab-account class="mt-4" :data="user_data" /> -->
                    </div>
                </vs-tab>
                <vs-tab label="Configurations" icon-pack="feather" icon="icon-minus">
                    <div class="tab-text">
                        <deductions :paymentMode="paymentModeId" :userId="userId" />
                    <!-- <user-edit-tab-information class="mt-4" :data="user_data" /> -->
                    </div>
                </vs-tab>
               
            </vs-tabs>

        </vx-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeTab: 0,
        }

    }
}
</script>